import MainModel from "../../../../components/Models/main-model";
import {
    Box,
    Flex,
    FormLabel,
    Heading,
    Stack,
    Textarea,
    Button,
    VStack,
    HStack,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { closeSuspendReasonModel } from "../../../../modules/admin-modules/models/Actions";
import { useState } from "react";
import { deleteStudentRequest } from "../../../../modules/admin-modules/students/Actions";

const SuspendReasonModal = ({ studentData }) => {
    const openSuspendReason = useSelector((state) => state.model.isOpen33);
    const [reason, setReason] = useState("");
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.students.isLoading);


    const header = (
        <Box>
            <Heading textAlign="center" color="main_1" fontSize="24px">
                سبب إيقاف الطالب
            </Heading>
        </Box>
    );

    const handleSuspend = async () => {
        if (reason.trim()) {
            await dispatch(deleteStudentRequest(studentData?.id, reason.trim()));
            dispatch(closeSuspendReasonModel());
            setReason("");
        }
    };

    const closeFunc = () => {
        dispatch(closeSuspendReasonModel());
        setReason("");
    };

    const setReasonText = (reasonText) => () => {
        const subject = studentData?.subject?.name;
        setReason("Asquera: " + subject + " - \n\n لقد تم ايقاف حساب الطالب بسبب: " + reasonText);
        document.getElementById("suspend-reason").value = "Asquera: " + subject + " - \n\n لقد تم ايقاف حساب الطالب بسبب: " + reasonText;
    };

    return (
        <MainModel
            isLoading={isLoading}
            header={header}
            closeFunc={closeFunc}
            openVar={openSuspendReason}
            buttonTitle={"تأكيد الإيقاف"}
            buttonFunc={handleSuspend}
        >
            <VStack dir="rtl" spacing={4}>
                <HStack w="100%">
                    <FormLabel>الطالب: {studentData?.name}</FormLabel>
                </HStack>

                <VStack w="100%" spacing={2}>
                    <Button
                        w="100%"
                        onClick={setReasonText("عدم دفع المصروفات")}
                        colorScheme="orange"
                        variant="outline"
                    >
                        عدم دفع المصروفات
                    </Button>
                    <Button
                        w="100%"
                        onClick={setReasonText("الغياب عن السنتر")}
                        colorScheme="orange"
                        variant="outline"
                    >
                        الغياب عن السنتر
                    </Button>
                    <Button
                        w="100%"
                        onClick={setReasonText("عدم تسليم الواجبات")}
                        colorScheme="orange"
                        variant="outline"
                    >
                        عدم تسليم الواجبات
                    </Button>
                    <Button
                        w="100%"
                        onClick={setReasonText("عدم التفاعل وتراكم الحصص")}
                        colorScheme="orange"
                        variant="outline"
                    >
                        عدم التفاعل وتراكم الحصص
                    </Button>
                    <Button
                        w="100%"
                        onClick={setReasonText("عدم الرد على الاتصالات والرسائل المرسلة من الإدارة")}
                        colorScheme="orange"
                        variant="outline"
                    >
                        عدم الرد على الاتصالات والرسائل المرسلة من الإدارة
                    </Button>
                    <Button
                        w="100%"
                        onClick={setReasonText("مشاركة الأكاونت")}
                        colorScheme="orange"
                        variant="outline"
                    >
                        مشاركة الأكاونت
                    </Button>
                </VStack>

                <Box w="100%">
                    <FormLabel>السبب:</FormLabel>
                    <Textarea
                        id="suspend-reason"
                        bg="#f5f5f5"
                        placeholder="اكتب سبب الإيقاف"
                        onChange={(e) => setReason(e.target.value)}
                        rows={4}
                    />
                </Box>
            </VStack>
        </MainModel>
    );
};

export default SuspendReasonModal;

